import firebase from 'firebase'

var config = {
    apiKey: "AIzaSyAoObh6w2XFqPJivsN4uuh34HFsDclmXss",
    authDomain: "kitprep-75294.firebaseapp.com",
    databaseURL: "https://kitprep-75294.firebaseio.com",
    projectId: "kitprep-75294",
    storageBucket: "",
    messagingSenderId: "896545598723"
}
var fire = firebase.initializeApp(config)

export default fire


// WEBPACK FOOTER //
// ./src/fire.js